import React from 'react';
import clsx from 'clsx';
import greenTick from '../../../../../../../assets/green-tick.svg';
import { alertIcon } from '../../../../../../../assets/hostedassets';
import profileStyles from './UserProfile.module.scss';
import tabStyles from '../../../../ManagementProfileTab/ManagementProfileTab.module.scss';
import type { RegulatoryCountRowProps } from './ManagementUserProfile.types';
import { getCountRowStatus } from './managementUserProfileUtils';
import DrawerRow from './DrawerRow';
import ClickableValue from './ClickableValue';

const RegulatoryCountRow = ({
    label,
    count,
    locked,
    notReady,
    unitSingular,
    unitPlural,
    zeroLabel,
    onClickIfPositive,
    isPDFReport,
    mutedLabel,
    lockedTooltip,
}: RegulatoryCountRowProps) => {
    const status = getCountRowStatus(count, { locked, notReady, unitSingular, unitPlural, zeroLabel });
    const clickable = status.kind === 'alert' && !isPDFReport && !!onClickIfPositive;
    return (
        <DrawerRow
            label={label}
            mutedLabel={mutedLabel}
            valueOwnsStyling
            // Only a locked module gets a hint; "absent" and "not ready" are just
            // no-data-yet and don't need explaining.
            title={status.kind === 'dash' && locked ? lockedTooltip : undefined}
            value={
                status.kind === 'dash' ? undefined : (
                    <ClickableValue
                        clickable={clickable}
                        onClick={onClickIfPositive}
                        className={clsx(profileStyles.CountValue, { [tabStyles.alertClickable]: clickable })}
                    >
                        <span className={status.kind === 'positive' ? tabStyles.alertGrey : tabStyles.alertRed}>
                            {!isPDFReport && (
                                <img
                                    src={status.kind === 'positive' ? greenTick : alertIcon}
                                    alt={''}
                                    className={profileStyles.CountIcon}
                                />
                            )}
                            {status.label}
                        </span>
                    </ClickableValue>
                )
            }
        />
    );
};

export default RegulatoryCountRow;
